import { render, staticRenderFns } from "./followList.vue?vue&type=template&id=3476f478&scoped=true&"
import script from "./followList.vue?vue&type=script&lang=js&"
export * from "./followList.vue?vue&type=script&lang=js&"
import style0 from "./followList.vue?vue&type=style&index=0&id=3476f478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476f478",
  null
  
)

export default component.exports